import {
  ADD_FAVOURITE_BUSINESS_UNIT,
  ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS,
  FETCH_BUSINESS_UNIT,
  FETCH_BUSINESS_UNIT_SUCCESS,
  FETCH_ALL_BUSINESS_UNIT,
  FETCH_ALL_BUSINESS_UNIT_SUCCESS,
  FILTER_BUSINESS_UNIT,
  GET_ALL_BUSINESS_UNIT,
  GET_UNSELECTED_ALL_BUSINESS_UNIT,
  HANDLE_BUSINESS_UNIT_REQUEST_CLOSE,
  HIDE_BUSINESS_UNIT_LOADER,
  SHOW_BUSINESS_UNIT_LOADER,
  ON_ADD_BUSINESS_UNIT,
  ON_ALL_BUSINESS_UNIT_SELECT,
  ON_BUSINESS_UNIT_CLOSE,
  ON_BUSINESS_UNIT_SELECT,
  ON_DELETE_BUSINESS_UNIT,
  ON_DELETE_BUSINESS_UNIT_SUCCESS,
  ON_FILTER_SELECTED_BUSINESS_UNIT,
  ON_FILTER_BUSINESS_UNIT_OPTION_SELECT,
  ON_SAVE_BUSINESS_UNIT,
  ON_SAVE_BUSINESS_UNIT_SUCCESS,
  ON_TOGGLE_BUSINESS_UNIT_DRAWER,
  SHOW_BUSINESS_UNIT_MESSAGE,
  UPDATE_SEARCH_BUSINESS_UNIT,
} from 'constants/ActionTypes';

export const fetchBusinessUnit = (payload) => {
  return {
      type: FETCH_BUSINESS_UNIT,
      payload
  };
};
export const fetchBusinessUnitSuccess = (payload) => {
  return {
      type: FETCH_BUSINESS_UNIT_SUCCESS,
      payload
  };
};
export const fetchBusinessUnits = () => {
  return {
      type: FETCH_ALL_BUSINESS_UNIT
  };
};
export const fetchBusinessUnitsSuccess = (payload) => {
  return {
      type: FETCH_ALL_BUSINESS_UNIT_SUCCESS,
      payload
  };
};
export const showBusinessUnitMessage = (message) => {
  return {
      type: SHOW_BUSINESS_UNIT_MESSAGE,
      payload: message
  };
};
export const addFavouriteBusinessUnit = (payload) => {
  return {
      type: ADD_FAVOURITE_BUSINESS_UNIT,
      payload
  };
};
export const addFavouriteBusinessUnitSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS,
      payload
  };
};
export const onBusinessUnitSelect = (payload) => {
  return {
      type: ON_BUSINESS_UNIT_SELECT,
      payload
  };
};
export const onAddBusinessUnit = () => {
  return {
      type: ON_ADD_BUSINESS_UNIT,
      payload: ''
  };
};
export const onBusinessUnitClose = () => {
  return {
      type: ON_BUSINESS_UNIT_CLOSE,
      payload: ''
  };
};
export const onFilterBusinessUnitOptionSelect = (payload) => {
  return {
      type: ON_FILTER_BUSINESS_UNIT_OPTION_SELECT,
      payload
  };
};
export const onSaveBusinessUnit = (payload) => {
  return {
      type: ON_SAVE_BUSINESS_UNIT,
      payload
  };
};
export const onSaveBusinessUnitSuccess = (data) => {
  return {
      type: ON_SAVE_BUSINESS_UNIT_SUCCESS,
      payload: data
  };
};
export const onDeleteBusinessUnit = (payload) => {
  return {
      type: ON_DELETE_BUSINESS_UNIT,
      payload
  };
};
export const onDeleteBusinessUnitSuccess = (payload) => {
  return {
      type: ON_DELETE_BUSINESS_UNIT_SUCCESS,
      payload
  };
};
export const onFilterSelectedBusinessUnit = () => {
  return {
      type: ON_FILTER_SELECTED_BUSINESS_UNIT,
      payload: ''
  };
};
export const filterBusinessUnit = (payload) => {
  return {
      type: FILTER_BUSINESS_UNIT,
      payload
  };
};
export const getAllBusinessUnit = () => {
  return {
      type: GET_ALL_BUSINESS_UNIT,
      payload: ''
  };
};
export const getUnselectedAllBusinessUnit = () => {
  return {
      type: GET_UNSELECTED_ALL_BUSINESS_UNIT,
      payload: ''
  };
};
export const onAllBusinessUnitSelect = () => {
  return {
      type: ON_ALL_BUSINESS_UNIT_SELECT,
      payload: ''
  };
};
export const updateSearchBusinessUnit = (payload) => {
  return {
      type: UPDATE_SEARCH_BUSINESS_UNIT,
      payload
  };
};
export const onToggleBusinessUnitDrawer = () => {
  return {
      type: ON_TOGGLE_BUSINESS_UNIT_DRAWER,
  };
};
export const handleBusinessUnitRequestClose = () => {
  return {
      type: HANDLE_BUSINESS_UNIT_REQUEST_CLOSE,
  };
};
export const showBusinessUnitLoader = () => {
  return {
      type: SHOW_BUSINESS_UNIT_LOADER,
  };
};
export const hideBusinessUnitLoader = () => {
  return {
      type: HIDE_BUSINESS_UNIT_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/businessUnit.js